<template>
  <div class="details">
    <h4 class="text-center">VITAMINA B4 (ADENINA)</h4>
    <p>É uma purina, liga vitamina B2 e B3, ela é importante na formação da energia dos seres vivos.</p>
    <h5>Alimentos fonte de ADENINA</h5>
    <p>Vegetais verde escuro, cereais integrais, feijão, amêndoas e abacate.</p>
  </div>
</template>
